// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__299vt","colMaxWidth":"Table_colMaxWidth__29JNh"};